<ion-popover #popoverWeekDate [trigger]="'trigger_'+this.formName" side="bottom" alignment="center">
    <ng-template>    
        <ion-label>{{this.labelInput}}</ion-label>
        
        <div class="period_selection">                         
            <ion-select label="{{'MONTH' | translate}}" label-placement="stacked" interface="popover" [value]="this.month" (ionChange)="this.selectMonth($event)">
                @for(month of months; track $index){
                    <ion-select-option [value]="month.num">{{month.name | translate}}</ion-select-option>
                }
            </ion-select>
            <ion-select label="{{'YEAR' | translate}}" label-placement="stacked" interface="popover" [value]="this.year" (ionChange)="this.selectYear($event)">
                @for(year of years; track $index){
                    <ion-select-option [value]="year">{{year}}</ion-select-option>
                }
            </ion-select>  
        </div>        
        
        <div class="weeks_list">
            <div class="week_headers">
                <div class="week_header"></div>
                <div class="week_header">{{'DAY_SHORT_MONDAY' | translate}}</div>
                <div class="week_header">{{'DAY_SHORT_TUESDAY' | translate}}</div>
                <div class="week_header">{{'DAY_SHORT_WEDNESDAY' | translate}}</div>
                <div class="week_header">{{'DAY_SHORT_THURSDAY' | translate}}</div>
                <div class="week_header">{{'DAY_SHORT_FRIDAY' | translate}}</div>
                <div class="week_header">{{'DAY_SHORT_SATERDAY' | translate}}</div>
                <div class="week_header">{{'DAY_SHORT_SUNDAY' | translate}}</div>
            </div>
            @for(week of this.weeks; track $index){
                <div class="week" [class.current]="week.currentWeek" [class.selected]="week.selectedWeek" (click)="this.selectWeek(week)">
                    <div class="num_week">{{week.startDate | marvDateToString: 'WW'}}</div>
                    @for(day of week.days; track $index){
                        <div class="day" [class.today]="day.today"  [class.different_month]="day.differentMonth">
                            {{day.date | marvDateToString: 'D'}}
                        </div>
                    }
                </div>
            }
        </div>
        
        <div class="buttons_popover">
            <ion-button color="primary" fill="clear" (click)="this.confirmWeek()">{{'VALIDATE' | translate}}</ion-button>
            <ion-button color="primary" fill="clear" (click)="this.closeWeekPicker()">{{'CANCEL' | translate}}</ion-button>
        </div>
    </ng-template>
</ion-popover>

<div 
    class="marv_select_week"
    [class.no_margin]="this.noMargin"   
    [class.disabled]="this.disabled" 
    >
    
    <div class="marv_select_week_trigger" [id]="(!this.disabled ? 'trigger_'+this.formName : '')">
        @if(this.withSpeechToText){
            <ion-icon class="marv_input_icon_speech" name="mic-outline" (click)="this.speechToText($event)"></ion-icon>
        }
    </div>
    
    @if(this.iconInput !== ''){
        <ion-icon class="marv_select_week_icon_prefix" [name]="this.iconInput"></ion-icon>
    }
    
    @if(this.isRequired){
        <div class="marv_input_required">*</div>
    }
    
    @if(this.fixedLabel){
        <div class="marv_input_fixed_label">{{this.labelInput}}</div>
    }
    
    <input 
        type="text" 
        [placeholder]="(!this.fixedLabel ? this.labelInput : '')" 
        autocomplete="off"
        value="{{'WEEK' | translate}} {{this.formGroupDirective.form.controls[this.formName].value | marvDateToString: 'WW - GGGG'}}"        
        disabled
        />    
    
    <input type="hidden" [name]="this.formName" [formControlName]="this.formName" />    
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}

@if(this.withSpeechToText){
    <marv-speech-to-text #marvSpeechToText (onDidDismiss)="this.onDismissSpeechToText($event)"/>
}